import { render, staticRenderFns } from "./dictionaryInput.vue?vue&type=template&id=15e5cc23"
import script from "./dictionaryInput.vue?vue&type=script&lang=js"
export * from "./dictionaryInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports